import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import CTASection from '../components/CTASection';

const Photos = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Gallery images - locally hosted
  const galleryImages = [
    { url: "/images/photo1.jpg", title: "Creative Art Time!", rotation: "-2deg" },
    { url: "/images/photo2.jpg", title: "Making Masterpieces!", rotation: "3deg" },
    { url: "/images/photo3.jpg", title: "Learning is Fun!", rotation: "-1deg" },
    { url: "/images/photo4.jpg", title: "Play & Learn!", rotation: "2deg" },
    { url: "/images/photo5.jpg", title: "Buddies Forever!", rotation: "-3deg" },
    { url: "/images/photo6.jpg", title: "Story Time!", rotation: "1deg" },
    { url: "/images/photo7.jpg", title: "Yummy Snack Time!", rotation: "-2deg" },
    { url: "/images/photo8.jpg", title: "Friends Together!", rotation: "3deg" },
    { url: "/images/photo9.jpg", title: "Outdoor Adventures!", rotation: "-1deg" },
    { url: "/images/gallery1.jpg", title: "Little Explorer!", rotation: "2deg" },
    { url: "/images/gallery2.jpg", title: "So Much Fun!", rotation: "-1deg" },
    { url: "/images/gallery3.jpg", title: "Giggles & Games!", rotation: "3deg" },
    { url: "/images/gallery4.jpg", title: "Happy Hands!", rotation: "-2deg" },
    { url: "/images/gallery5.jpg", title: "Playtime Pals!", rotation: "1deg" },
    { url: "/images/gallery6.jpg", title: "Tiny Adventurers!", rotation: "-3deg" },
    { url: "/images/gallery7.jpg", title: "Silly Smiles!", rotation: "2deg" },
    { url: "/images/gallery8.jpg", title: "Growing Together!", rotation: "-1deg" },
    { url: "/images/gallery9.jpg", title: "Fun All Day!", rotation: "3deg" },
    { url: "/images/gallery10.jpg", title: "Snuggle Time!", rotation: "-2deg" },
    { url: "/images/gallery11.jpg", title: "Best of Friends!", rotation: "1deg" },
    { url: "/images/gallery12.jpg", title: "Curious Minds!", rotation: "-3deg" },
    { url: "/images/gallery13.jpg", title: "Sweet Moments!", rotation: "2deg" },
    { url: "/images/gallery14.jpg", title: "Playful Days!", rotation: "-1deg" },
    { url: "/images/gallery15.jpg", title: "Joy & Laughter!", rotation: "3deg" },
    { url: "/images/gallery16.jpg", title: "Little Champs!", rotation: "-2deg" },
    { url: "/images/gallery17.jpg", title: "Happy Hearts!", rotation: "1deg" },
    { url: "/images/gallery18.jpg", title: "Discover & Grow!", rotation: "-3deg" },
    { url: "/images/gallery19.jpg", title: "Tiny Dancer!", rotation: "2deg" },
    { url: "/images/gallery20.jpg", title: "Sunshine Smiles!", rotation: "-1deg" },
    { url: "/images/gallery21.jpg", title: "Peek-a-Boo!", rotation: "3deg" },
    { url: "/images/gallery22.jpg", title: "Wonder World!", rotation: "-2deg" },
    { url: "/images/gallery23.jpg", title: "Gentle Moments!", rotation: "1deg" },
    { url: "/images/gallery24.jpg", title: "Fun With Friends!", rotation: "-3deg" },
    { url: "/images/gallery25.jpg", title: "Adventure Awaits!", rotation: "2deg" },
    { url: "/images/gallery26.jpg", title: "Cozy Cuties!", rotation: "-1deg" },
    { url: "/images/gallery27.jpg", title: "Dream Big!", rotation: "3deg" },
    { url: "/images/gallery28.jpg", title: "Playtime Magic!", rotation: "-2deg" },
    { url: "/images/gallery29.jpg", title: "Happy Together!", rotation: "1deg" },
    { url: "/images/gallery30.jpg", title: "Endless Fun!", rotation: "-3deg" }
  ];

  const tapeColors = ['bg-yellow-300', 'bg-pink-300', 'bg-blue-300', 'bg-green-300', 'bg-purple-300'];

  const openLightbox = (index) => {
    setSelectedImage(galleryImages[index]);
    setCurrentIndex(index);
  };

  const closeLightbox = () => setSelectedImage(null);

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Fun Background Pattern */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-100 via-pink-50 to-purple-100"></div>
        <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: `radial-gradient(circle, #FFB6C1 10%, transparent 10%), 
                           radial-gradient(circle, #87CEEB 10%, transparent 10%),
                           radial-gradient(circle, #DDA0DD 10%, transparent 10%)`,
          backgroundSize: '60px 60px, 80px 80px, 100px 100px',
          backgroundPosition: '0 0, 30px 30px, 60px 20px'
        }}></div>
      </div>

      {/* Hero Section */}
      <section className="relative py-12 md:py-20 px-4">
        <div className="absolute top-10 left-10 w-20 h-20 bg-yellow-300 rounded-full opacity-60 animate-bounce" style={{ animationDuration: '3s' }}></div>
        <div className="absolute top-20 right-20 w-16 h-16 bg-pink-300 rounded-full opacity-60 animate-bounce" style={{ animationDuration: '2.5s', animationDelay: '0.5s' }}></div>
        <div className="absolute bottom-10 left-1/4 w-12 h-12 bg-purple-300 rounded-full opacity-60 animate-bounce" style={{ animationDuration: '4s' }}></div>

        <div className="container mx-auto text-center relative z-10">
          <div className="mb-6">
            <h1 className="text-5xl md:text-7xl font-black tracking-tight">
              <span className="text-pink-500">O</span>
              <span className="text-yellow-500">u</span>
              <span className="text-purple-500">r</span>
              <span className="text-pink-500"> </span>
              <span className="text-blue-500">P</span>
              <span className="text-green-500">h</span>
              <span className="text-orange-500">o</span>
              <span className="text-pink-500">t</span>
              <span className="text-purple-500">o</span>
              <span className="text-yellow-500">s</span>
              <span className="text-blue-500">!</span>
            </h1>
          </div>
          
          <div className="inline-block bg-gradient-to-r from-purple-500 via-pink-500 to-yellow-500 text-white px-8 py-3 rounded-full shadow-lg transform -rotate-2 mb-8">
            <p className="text-lg md:text-xl font-bold">See What Fun We Have Every Day!</p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-8">
            <div className="bg-white/80 backdrop-blur-sm px-6 py-4 rounded-2xl shadow-lg border-4 border-pink-300 transform hover:scale-110 transition-transform cursor-pointer rotate-2">
              <p className="text-3xl font-black text-pink-500">39</p>
              <p className="text-sm font-bold text-gray-600">Happy Photos</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm px-6 py-4 rounded-2xl shadow-lg border-4 border-yellow-300 transform hover:scale-110 transition-transform cursor-pointer -rotate-2">
              <p className="text-3xl font-black text-yellow-500">100%</p>
              <p className="text-sm font-bold text-gray-600">Fun Times</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm px-6 py-4 rounded-2xl shadow-lg border-4 border-purple-300 transform hover:scale-110 transition-transform cursor-pointer rotate-1">
              <p className="text-3xl font-black text-purple-500">LOTS</p>
              <p className="text-sm font-bold text-gray-600">Of Smiles!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Scrapbook Photo Gallery */}
      <section className="py-12 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block bg-white px-8 py-4 rounded-2xl shadow-xl border-4 border-dashed border-purple-400 transform -rotate-1">
              <h2 className="text-3xl md:text-4xl font-black text-purple-600">
                Click Any Photo to See It Big!
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
            {galleryImages.map((image, index) => (
              <div 
                key={index}
                data-testid={`photo-card-${index}`}
                className="group cursor-pointer"
                onClick={() => openLightbox(index)}
                style={{ transform: `rotate(${image.rotation})` }}
              >
                <div className="bg-white p-3 pb-16 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:rotate-0 relative">
                  <div className={`absolute -top-3 left-1/2 transform -translate-x-1/2 w-16 h-6 ${tapeColors[index % tapeColors.length]} opacity-80 rounded-sm rotate-3`}></div>
                  
                  <div className="relative overflow-hidden rounded">
                    <img 
                      src={image.url}
                      alt={image.title}
                      className="w-full h-56 md:h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                  
                  <div className="absolute bottom-3 left-0 right-0 text-center">
                    <p className="text-lg font-bold text-gray-700" style={{ fontFamily: 'Comic Sans MS, cursive' }}>
                      {image.title}
                    </p>
                    <div className="flex justify-center gap-1 mt-1">
                      <span className="text-yellow-400">★</span>
                      <span className="text-pink-400">★</span>
                      <span className="text-purple-400">★</span>
                    </div>
                  </div>

                  <div className="absolute top-6 right-6 w-3 h-3 bg-pink-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  <div className="absolute top-6 left-6 w-3 h-3 bg-yellow-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection />

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          data-testid="lightbox-modal"
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <div className="absolute inset-4 border-8 border-dashed border-white/20 rounded-3xl pointer-events-none"></div>
          
          <button 
            data-testid="lightbox-close"
            onClick={closeLightbox}
            className="absolute top-6 right-6 bg-pink-500 hover:bg-pink-600 text-white rounded-full p-3 shadow-lg transition-all hover:scale-110 z-50"
          >
            <X className="h-8 w-8" />
          </button>
          
          <button 
            data-testid="lightbox-prev"
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-4 md:left-8 bg-yellow-400 hover:bg-yellow-500 text-purple-800 rounded-full p-4 shadow-lg transition-all hover:scale-110"
          >
            <ChevronLeft className="h-8 w-8" />
          </button>
          
          <div className="max-w-4xl relative" onClick={(e) => e.stopPropagation()}>
            <div className="bg-white p-4 pb-20 rounded-lg shadow-2xl">
              <img 
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-full max-h-[60vh] object-contain rounded"
              />
              <div className="absolute bottom-6 left-0 right-0 text-center">
                <p className="text-2xl font-bold text-gray-700" style={{ fontFamily: 'Comic Sans MS, cursive' }}>
                  {selectedImage.title}
                </p>
              </div>
            </div>
          </div>
          
          <button 
            data-testid="lightbox-next"
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-4 md:right-8 bg-yellow-400 hover:bg-yellow-500 text-purple-800 rounded-full p-4 shadow-lg transition-all hover:scale-110"
          >
            <ChevronRight className="h-8 w-8" />
          </button>

          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 bg-purple-500 text-white px-6 py-2 rounded-full font-bold shadow-lg">
            {currentIndex + 1} of {galleryImages.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default Photos;
